import log from 'loglevel'
import { isEmpty, isNil, keys, map, split } from 'lodash/fp'

import stepContents from './steps.json'
import { useTour } from '@reactour/tour'
import { Typography } from '@mui/material'

log.setLevel((process.env['LOG_LEVEL'] as log.LogLevelDesc) ?? log.levels.DEBUG)

export const getStep = (key: string): any => {
  const contents = stepContents[key]
  if (isNil(contents)) return undefined
  return map((key: string) => ({
    selector: `#${key}`,
    content: map((line: string) => (
      <Typography variant="body1">{line}</Typography>
    ))(split('\n')(contents[key]))
  }))(keys(contents))
}

export const useTourControl = (
  key: string
): { setIsOpen: (value: React.SetStateAction<boolean>) => void } => {
  const { setIsOpen: setIsOpenHook, meta, setMeta } = useTour()
  const setIsOpen = (open: React.SetStateAction<boolean>): void => {
    if (isNil(setMeta)) return
    const done: Record<string, boolean> =
      !isEmpty(meta) && !isNil(meta) ? JSON.parse(meta) : {}
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (isNil(done[key]) || !done[key]) {
      setMeta(JSON.stringify({ [key]: true }))
      setIsOpenHook(open)
    }
  }
  return { setIsOpen }
}
